'use strict';

var _find = require('lodash/find');

var _find2 = _interopRequireDefault(_find);

var _clone = require('lodash/clone');

var _clone2 = _interopRequireDefault(_clone);

var _pull = require('lodash/pull');

var _pull2 = _interopRequireDefault(_pull);

var _filter = require('lodash/filter');

var _filter2 = _interopRequireDefault(_filter);

var _adSlotFactory = require('./adSlotFactory');

var _adSlotFactory2 = _interopRequireDefault(_adSlotFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mySlots = [];
var companionSlots = [];

var adSlotManager = {
  addSlot: function addSlot(slotName, elementId, dimensions) {
    var slot = (0, _find2.default)(mySlots, ['elementId', elementId]);
    if (!slot) {
      slot = _adSlotFactory2.default.createAdSlot(slotName, elementId, dimensions);
      if (slot) {
        mySlots.push(slot);
      }
    }

    return slot;
  },
  removeSlot: function removeSlot(elementId) {
    var slot = (0, _find2.default)(mySlots, ['elementId', elementId]);
    if (slot) {
      (0, _pull2.default)(mySlots, slot);
    }

    return slot;
  },
  getSlot: function getSlot(elementId) {
    return this.getSlotWhere(['elementId', elementId]);
  },
  getDisplaySlots: function getDisplaySlots() {
    return this.getSlotsWhere(function (_slot) {
      return _slot.medium === 'display';
    });
  },
  getSlotWhere: function getSlotWhere(predicate) {
    return (0, _find2.default)(mySlots, predicate);
  },
  getSlotsWhere: function getSlotsWhere(predicate) {
    return (0, _filter2.default)(mySlots, predicate);
  },
  getSlots: function getSlots() {
    return (0, _clone2.default)(mySlots);
  },
  addCompanionSlot: function addCompanionSlot(slot) {
    companionSlots.push(slot);
  },
  getCompanionSlots: function getCompanionSlots() {
    return (0, _clone2.default)(companionSlots);
  },
  resetCompanionSlots: function resetCompanionSlots() {
    companionSlots = [];
  }
};

module.exports = adSlotManager;